import React, { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import { handleErrors } from "../modules/handleErrors";
import { toast } from "react-toastify";
import CategoriesListedit from "../web-pages/category-page/CategoriesListedit";
import LoadingSpinner from "../components/LoadingSpinner";
import { Modal } from "react-bootstrap";

export const CategoriesEdit = () => {
  const [categories, setcategories] = useState([]);
  const [category, setcategory] = useState("");
  const [editItem, seteditItem] = useState("");
  const [categoryId, setcategoryId] = useState(null);
  const [subcategoryId, setsubcategoryId] = useState(null);
  const [subsubcategoryId, setsubsubcategoryId] = useState(null);
  const [Subcategory, setSubcategory] = useState("");
  const [Subsubcategory, setSubsubcategory] = useState("");
  const [subcategories, setsubcategories] = useState([]);
  const [Loading, setLoading] = useState(false);
  const [categoryloader, setcategoryloader] = useState(false);
  const [Subcategoryloader, setSubcategoryloader] = useState(false);
  const [Subsubcategoryloader, setSubsubcategoryloader] = useState(false);
  const [categoriesdata, setcategoriesdata] = useState([]);
  const [editmodle, seteditmodle] = useState(false);

  const fetchcategories = async () => {
    const result = await apiClient.get("/categories/");
    if (result.ok) setcategories(result?.data?.results);
  };

  const fetchsubcategories = async (catId) => {
    const result = await apiClient.get(`/subcategory/`);
    if (result.ok) setsubcategories(result?.data?.results || []);
  };

  useEffect(() => {
    fetchcategories();
    fetchsubcategories(categoryId);
  }, []);

  // useEffect(() => {
  //   fetchsubcategories(categoryId);
  //   setsubcategoryId(null); // Reset subcategory selection when category changes
  // }, [categoryId]);

  const postsetcategories = async (e) => {
    e.preventDefault();

    try {
      setcategoryloader(true);
      const result = await apiClient.post("/categories/", { name: category });
      setcategoryloader(false);
      if (!result.ok) handleErrors(result.data);
      toast.success("add category succecfully");
      fetchcategories();
      fetchcategoriesdata();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const postSubcategories = async (e) => {
    e.preventDefault();

    try {
      setSubcategoryloader(true);
      const result = await apiClient.post("/subcategory/", {
        name: Subcategory,
        category: categoryId,
      });
      setSubcategoryloader(false);
      if (!result.ok) handleErrors(result.data);
      toast.success("Add subcategory succecfully");

      fetchcategoriesdata();
      fetchsubcategories(); // Refresh subcategories list
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const postSubsubcategories = async (e) => {
    e.preventDefault();

    try {
      setSubsubcategoryloader(true);
      const result = await apiClient.post("/subsubcategories/", {
        name: Subsubcategory,
        subcategory: subcategoryId,
      });

      if (!result.ok) handleErrors(result.data);
      toast.success("Add sub subcategory successfully");
      setSubsubcategoryloader(false);
      setSubsubcategory("");
      setsubcategoryId(null);
      fetchcategoriesdata();
    } catch (error) {
      console.error("Error:", error);
      setSubsubcategory("");
      setsubcategoryId(null);
    }
  };

  const fetchcategoriesdata = async () => {
    try {
      setLoading(true);

      // Step 1: Fetch all categories with subcategories
      const categoriesRes = await apiClient.get("/categories/GetAll/");
      if (!categoriesRes.ok) throw new Error("Failed to fetch categories");

      const categories = categoriesRes.data;

      // Step 2: Fetch all subsubcategories in one call
      const subsubcategoriesRes = await apiClient.get("/subsubcategories/");
      if (!subsubcategoriesRes.ok)
        throw new Error("Failed to fetch subsubcategories");

      const allSubsubcategories = subsubcategoriesRes?.data || [];
      // Step 3: Group subsubcategories by subcategory ID
      const subsubcategoriesBySubcategory = allSubsubcategories.reduce(
        (acc, subsub) => {
          const subcategoryId = subsub.subcategory;
          if (!acc[subcategoryId]) {
            acc[subcategoryId] = [];
          }
          acc[subcategoryId].push(subsub);
          return acc;
        },
        {}
      );

      // Step 4: Merge subsubcategories into subcategories
      const categoriesWithSubsub = categories.map((category) => {
        const subcategoriesWithSubsub = category.subcategories.map(
          (subcategory) => ({
            ...subcategory,
            subsubcategories:
              subsubcategoriesBySubcategory[subcategory.id] || [],
          })
        );

        return {
          ...category,
          subcategories: subcategoriesWithSubsub,
        };
      });

      setcategoriesdata(categoriesWithSubsub);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchcategoriesdata();
  }, []);

  return (
    <div className="container">
      {Loading ? (
        <div className="d-flex justify-content-center mt-5">
          <LoadingSpinner color="#FF3E1F" />
        </div>
      ) : (
        <div className=" row justify-content-start  rounded-3 ">
          <div className="col-md-6 ">
            <div className="shadow  p-4 rounded-3">
              {/* { editmodle && <ModalFormRemove  showRemove={editmodle} modalCloseRemove={()=>{seteditmodle(false)}} setcategoryId={setcategoryId} categoryId={categoryId}      fetch={()=>{    fetchcategories()
                        fetchcategoriesdata()}} subcategoryId={subcategoryId}
                        editItem={editItem}
                        />} */}

              <div className="">
                <h5 className="">Categories</h5>

                <input
                  className="form-control"
                  onChange={(e) => setcategory(e.target.value)}
                  value={category}
                  type="text "
                />
              </div>
              <button
                className="btn red-btn mx-auto text-center mt-3"
                onClick={postsetcategories}
              >
                {categoryloader ? "Add..." : "Add"}
              </button>
            </div>

            <div className=" ">
              <div className="shadow  my-3 p-4 rounded-3">
                <div className="">
                  <select
                    class="form-select"
                    aria-label="Default select example"
                    onChange={(e) => setcategoryId(e.target.value)}
                  >
                    <option selected disabled>
                      Open this select menu
                    </option>
                    {categories.map((item) => (
                      <option value={item?.id}>{item?.name} </option>
                    ))}
                  </select>

                  <h5 className="mt-2">Sub Categories</h5>

                  <input
                    className="form-control"
                    type="text "
                    onChange={(e) => setSubcategory(e.target.value)}
                    value={Subcategory}
                  />
                </div>
                <button
                  className="btn red-btn mx-auto text-center mt-3"
                  onClick={postSubcategories}
                >
                  {Subcategoryloader ? "Add..." : "Add"}
                </button>
              </div>
            </div>

            {/* New Sub Sub Categories Section */}
            <div className=" ">
              <div className="shadow  my-3 p-4 rounded-3">
                <div className="">
                  <select
                    class="form-select"
                    aria-label="Select subcategory"
                    onChange={(e) => setsubcategoryId(e.target.value)}
                  >
                    <option selected disabled>
                      Select subcategory
                    </option>
                    {subcategories.map((item) => (
                      <option key={item?.id} value={item?.id}>
                        {item?.name}{" "}
                      </option>
                    ))}
                  </select>

                  <h5 className="mt-2">Sub Sub Categories</h5>

                  <input
                    className="form-control"
                    type="text "
                    onChange={(e) => setSubsubcategory(e.target.value)}
                    value={Subsubcategory}
                    disabled={!subcategoryId}
                  />
                </div>
                <button
                  className="btn red-btn mx-auto text-center mt-3"
                  onClick={postSubsubcategories}
                  disabled={!subcategoryId}
                >
                  {Subsubcategoryloader ? "Add..." : "Add"}
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div
              className="rounded-4 px-md-4  py-md-5 py-3 px-2 "
              style={{ backgroundColor: "#BBC6CA" }}
            >
              <CategoriesListedit
                seteditItem={seteditItem}
                fetchcategories={fetchcategories}
                categoriesdata={categoriesdata}
                fetchcategoriesdata={fetchcategoriesdata}
                setcategoryId={setcategoryId}
                seteditmodle={seteditmodle}
                setSubcategory={setSubcategory}
                setsubcategoryId={setsubcategoryId}
                setSubsubcategory={setSubsubcategory}
                setsubsubcategoryId={setsubsubcategoryId}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const ModalFormRemove = ({
  showRemove,
  modalCloseRemove,
  categoryId,
  fetch,
  setcategoryId,
  subcategoryId,
  subsubcategoryId,
  editItem,
}) => {
  const [Loader, setLoader] = useState(false);
  const [value, setvalue] = useState(editItem);

  const handleRegister = async (e) => {
    e.preventDefault();

    try {
      setLoader(true);
      let endpoint = "";
      let id = "";

      if (subsubcategoryId) {
        endpoint = "subsubcategory";
        id = subsubcategoryId;
      } else if (subcategoryId) {
        endpoint = "subcategory";
        id = subcategoryId;
      } else {
        endpoint = "categories";
        id = categoryId;
      }

      const response = await apiClient.put(`/${endpoint}/${id}/`, {
        name: value,
      });
      setLoader(false);

      if (!response.ok) return handleErrors(response.data);

      let itemType = subsubcategoryId
        ? "sub subcategory"
        : subcategoryId
        ? "subcategory"
        : "category";
      toast.success(`Edit ${itemType} successfully`);

      fetch();
      setcategoryId("");
      modalCloseRemove("");
    } catch (error) {}
  };

  return (
    <Modal
      show={showRemove}
      onHide={modalCloseRemove}
      dialogClassName="alert-modal"
      centered
    >
      <Modal.Body
        style={{
          padding: "40px 30px",
          background: "#F8D4B7",
          borderTopRightRadius: "24px",
          borderBottomLeftRadius: "24px",
        }}
      >
        <section className="text-center">
          <p>Are you sure you want to Edit?</p>
          <input
            className="form-control"
            type="text"
            value={value}
            onChange={(e) => setvalue(e.target.value)}
          />
          <div className="d-flex  justify-content-between align-items-center">
            <div>
              <button
                disabled={Loader}
                className="btn grey-btn mt-3 px-5"
                style={{
                  width: "190px",
                  paddingTop: "8px",
                  paddingBottom: "8px !important",
                }}
                onClick={handleRegister}
              >
                {Loader ? "I'm Sure..." : "I'm Sure"}
              </button>
            </div>

            <div>
              <button
                className="btn bg-white px-5 mt-3"
                style={{ width: "190px", border: "2px solid #000" }}
                onClick={modalCloseRemove}
              >
                Cancel
              </button>
            </div>
          </div>
        </section>
      </Modal.Body>
    </Modal>
  );
};
